import { ManageCardsLayout } from '@manage-cards/containers';
import { usePhonePeLogin } from '@manage-cards/hooks/usePhonepeLogin';
import { IUserSummaryDetails } from '@manage-cards/types';

export default function App() {
	const { isLoggedIn, isInitializing, userDetails, loginViaPhonePe, logout } =
		usePhonePeLogin();
	return (
		<ManageCardsLayout
			isLoggedIn={isLoggedIn}
			isInitializing={isInitializing}
			userDetails={userDetails as IUserSummaryDetails}
			loginViaPhonePe={loginViaPhonePe}
			logout={logout}
		/>
	);
}
